import {
  getDwgConversion,
  postStartDwgConversion,
} from 'scenes/ProjectBank/services/dwgConversion.service';

/** How often the viewer asks whether a conversion has finished. */
export const DWG_POLL_MS = 3000;

/**
 * Past this the viewer stops waiting: the converter's own limit (10 min)
 * and a margin, as the API's DWG_CONVERSION_STALE_MS.
 */
export const DWG_WAIT_MS = 12 * 60 * 1000;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Gets a bank DWG file's 3D model from the server's converter: starts the
 * conversion when there is none yet and waits for it to end. A file
 * converted once opens at once after that.
 * @param {Object} file the raw bank item
 * @param {Function} [isCancelled] stops the waiting when it returns true
 * @returns {Promise<{status: 'done'|'failed'|'cancelled', glbUrl?: string,
 *   approximatedFaces?: number, error?: string}>}
 */
export async function convertDwg(file, isCancelled = () => false) {
  let state = await postStartDwgConversion(file);
  const startedAt = Date.now();

  while (state.status === 'running' || state.status === 'none') {
    if (Date.now() - startedAt > DWG_WAIT_MS) {
      return { status: 'failed', error: 'conversion_lost' };
    }
    await wait(DWG_POLL_MS);
    if (isCancelled()) return { status: 'cancelled' };
    state = await getDwgConversion(file);
  }
  return state;
}

export default convertDwg;
